import { createSlice } from "@reduxjs/toolkit";

// Lấy thông tin user từ localStorage nếu có (cho trường hợp refresh trang)
const initialState = {
  user:
    localStorage.getItem("user") &&
    localStorage.getItem("user") !== "null" &&
    localStorage.getItem("user") !== "undefined"
      ? JSON.parse(localStorage.getItem("user"))
      : null, // Lưu UserId và UserName
  customerInfor:
    localStorage.getItem("customerInfor") &&
    localStorage.getItem("customerInfor") !== "null" &&
    localStorage.getItem("customerInfor") !== "undefined"
      ? JSON.parse(localStorage.getItem("customerInfor"))
      : null,
  customerParentInfor:
    localStorage.getItem("customerParentInfor") &&
    localStorage.getItem("customerParentInfor") !== "null" &&
    localStorage.getItem("customerParentInfor") !== "undefined"
      ? JSON.parse(localStorage.getItem("customerParentInfor"))
      : null,
  roles:
    localStorage.getItem("roles") &&
    localStorage.getItem("roles") !== "null" &&
    localStorage.getItem("roles") !== "undefined"
      ? JSON.parse(localStorage.getItem("roles"))
      : null,
  isAuthenticated:
    localStorage.getItem("user") &&
    localStorage.getItem("user") !== "null" &&
    localStorage.getItem("user") !== "undefined"
      ? true
      : false, // Kiểm tra đã đăng nhập chưa
  isFirstLogin: false,
  unlockedDevPage: localStorage.getItem("dev_unlocked") || "0",
  isChangeBranch: false,
};

export const authSlice = createSlice({
  name: "auth", // Tên của slice
  initialState,
  reducers: {
    // Action khi đăng nhập thành công
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      state.customerInfor = action.payload.customerInfor;
      state.customerParentInfor = action.payload.customerParentInfor;
      state.isAuthenticated = true;
      state.isFirstLogin = true;
      // Lưu vào localStorage để duy trì trạng thái khi refresh trang
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("roles", JSON.stringify(action.payload.roles));
      localStorage.setItem(
        "customerInfor",
        JSON.stringify(action.payload.customerInfor),
      );
      localStorage.setItem(
        "customerParentInfor",
        JSON.stringify(action.payload.customerParentInfor),
      );
    },
    // Action khi đăng xuất
    logout: (state) => {
      state.user = null;
      state.roles = null;
      state.customerInfor = null;
      state.customerParentInfor = null;
      state.isAuthenticated = false;
      state.isFirstLogin = false;
      state.unlockedDevPage = "0";
      // Xóa khỏi localStorage
      localStorage.removeItem("user");
      localStorage.removeItem("roles");
      localStorage.removeItem("customerInfor");
      localStorage.removeItem("customerParentInfor");
      localStorage.removeItem("dev_unlocked");
    },
    clearFirstLogin: (state) => {
      state.isFirstLogin = false;
    },
    setUserData: (state, action) => {
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      state.customerInfor = action.payload.customerInfor;
      state.customerParentInfor = action.payload.customerParentInfor;
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("roles", JSON.stringify(action.payload.roles));
      localStorage.setItem(
        "customerInfor",
        JSON.stringify(action.payload.customerInfor),
      );
      localStorage.setItem(
        "customerParentInfor",
        JSON.stringify(action.payload.customerParentInfor),
      );
    },
    loginDevPage: (state, action) => {
      state.unlockedDevPage = "1";
      localStorage.setItem("dev_unlocked", "1");
    },
    changeBranch: (state) => {
      state.isChangeBranch = true;
    },
  },
});

export const {
  loginSuccess,
  logout,
  clearFirstLogin,
  setUserData,
  loginDevPage,
  changeBranch,
} = authSlice.actions;

export default authSlice.reducer;
